<template>
  <el-dialog class="dialog-simple" :visible.sync="visible" title="项目配置" width="680px" top="5vh" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" :size="size" ref="dataForm" label-position='right' label-width="100px" v-loading="dialogLoading">
      <el-form-item label="项目名称">
        <span>{{row.projectName}}</span>
      </el-form-item>
      <el-form-item label="客户企业">
        <span>{{row.clientCompanyName}}</span>
      </el-form-item>
      <el-form-item prop="type" label="类型">
        <el-select style="width: 100%;" v-model="dataForm.type" @change="handleTypeChange" :disabled="!isNewServiceSpecification" placeholder="请选择类型" filterable autocomplete="off" clearable>
          <el-option v-for="item in taskList" :key="item.value" :label="item.label" :value="item.value" ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="cycle" label="周期" v-if="dataForm.type === 3 || dataForm.type === 4">
        <el-select style="width: 100%;" v-model="dataForm.cycle" placeholder="请选择周期" :disabled="!isNewServiceSpecification" filterable autocomplete="off" clearable>
          <el-option v-for="item in cycleList" :key="item.value" :label="item.label" :value="item.value" ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="times" label="次数">
        <el-input v-model="dataForm.times" autocomplete="off" :disabled="!isNewServiceSpecification" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item prop="regionId" label="服务区域">
        <el-select style="width: 100%;" v-model="dataForm.regionId" placeholder="请选择服务区域" :disabled="!isNewProjectInServiceRegion" filterable autocomplete="off" clearable>
          <el-option v-for="item in regionList" :key="item.regionId" :label="item.name" :value="item.regionId" ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关联设备">
        <!-- <el-select style="width: 100%;" v-model="dataForm.measureId" placeholder="请选择关联设备" filterable autocomplete="off" clearable>
          <el-option v-for="item in regionList" :key="item.regionId" :label="item.name" :value="item.regionId" ></el-option>
        </el-select> -->
        <div class="tree-content">
          <el-tree
            :data="treeData"
            show-checkbox
            default-expand-all
            node-key="measureId"
            ref="tree"
            :check-strictly="checkStrictly"
            highlight-current
            :props="defaultProps">
          </el-tree>
        </div>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" slot="footer" style="text-align: right">
      <el-button class="submit" :size="size" type="primary" @click="submitHandle()" :loading="dialogLoading">确 定</el-button>
      <el-button class="close" :size="size" @click="visible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import tree from '@/utils/tree'
import debounce from 'lodash/debounce'
export default {
  name: 'projectConfig',
  props: {
  },
  data () {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      taskList: [
        { label: "站点改造", value: 1 },
        { label: "抢修", value: 2 },
        { label: "试验", value: 3 },
        { label: "巡检", value: 4 },
        { label: "其他", value: 5 }
      ],
      cycleList: [
        { label: "无", value: 0 },
        { label: "周(1/4月)", value: 1 },
        { label: "月(1月)", value: 2 },
        { label: "季度(3月)", value: 3 },
        { label: "半年(6月)", value: 4 },
        { label: "年(12月)", value: 5 }
      ],
      size: 'small',
      dialogLoading: false,
      checkStrictly: true,
      visible: false,
      serversList: [],
      clientServersList: [],
      dataForm: {
        type: '',
        config: '',
        remark: '',
        cycle: '',
        times: '',
        measureId: []
      },
      row: {},
      regionList: [],
      // 是否为新增服务规格
      isNewServiceSpecification: true,
      // 是否为新增服务区域
      isNewProjectInServiceRegion: true,
      // 是否为新增服务范围信息
      isNewProjectServiceScope: true,
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'measureName',
        disabled: this.disabledFn
      }
    }
  },
  computed: {
    dataRule () {
      return {
        type: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        cycle: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        times: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        regionId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        measureId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    disabledFn () {
      return this.isNewProjectServiceScope ? false : true
    },
    init (row) {
      console.log(row)
      this.row = Object.assign({}, row)
      this.checkStrictly = true
      this.isNewServiceSpecification = true
      this.isNewProjectInServiceRegion = true
      this.isNewProjectServiceScope = true
      this.visible = true
      this.dialogLoading = true
      this.dataForm = {
        type: '',
        config: '',
        remark: '',
        cycle: '',
        times: '',
        regionId: '',
        measureId: []
      }
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        const projectIdList = [this.row.projectId]
        const projectId = this.row.projectId
        const clientCompanyId = row.clientCompanyId
        Promise.all([
          this.$api.electricOperations.getMOViewTreeNodes(clientCompanyId).then((res) => {
            if (res.success) {
              const list = res.data
              this.treeData = tree.creatMeasureTreeJson(list, 0)
              this.checkStrictly = false
            }
          }),

          this.$api.electricOperations.listServiceRegionByCompanyId(0).then((res) => {
            if (res.success) {
              this.regionList = res.data
            }
          }),
          // this.$api.electricOperations.getOperationsMeasureInfo(clientCompanyId, -1).then((res) => {
          //   if (res.success) {
          //     this.regionList = res.data
          //   }
          // }),
          this.$api.contract.getSpecificationConfigInfo(projectIdList).then((res) => {
            if (res.success && res.data.length > 0) {
              this.isNewServiceSpecification = false
              this.dataForm.type = res.data[0].type
              this.dataForm.config = JSON.parse(res.data[0].config)
            }
          }),
          this.$api.contract.getProjectInServiceRegion(projectId).then((res) => {
            if (res.success && res.data !== null) {
              this.isNewProjectInServiceRegion = false
              this.dataForm.regionId = res.data.regionId
            }
          }),
          this.$api.contract.getProjectServiceScope(projectId).then((res) => {
            if (res.success) {
              this.isNewProjectServiceScope = (res.data === null || res.data?.length === 0) ? true : false
              this.dataForm.measureId = res.data.map((item) => {
                return item.measureId
              })
              this.$nextTick(() => {
                this.checkStrictly = false
                this.$refs.tree.setCheckedKeys(this.dataForm.measureId)
              })
            }
          })
        ]).then(() => {
          switch (this.dataForm.type) {
            case 3:
              this.dataForm.cycle = this.dataForm.config.cycle
              this.dataForm.times = this.dataForm.config.times
              break
            case 4:
              this.dataForm.cycle = this.dataForm.config.cycle
              this.dataForm.times = this.dataForm.config.times
              break
            default:
              this.dataForm.times = this.dataForm.config.times
              break
          }
          this.dialogLoading = false
        }).catch(() => { this.dialogLoading = false })
      })
    },
    handleTypeChange () {
      this.dataForm.cycle = ''
      this.dataForm.time = ''
    },
    submitHandle: debounce(function () {
      if (this.$refs.tree.getCheckedKeys().length === 0) {
        return this.$message.warning('请勾选关联设备')
      }
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        // this.dialogLoading = true
        switch (this.dataForm.type) {
          case 3:
            this.dataForm.config = JSON.stringify({
              cycle: this.dataForm.cycle,
              times: this.dataForm.times
            })
            break
          case 4:
            this.dataForm.config = JSON.stringify({
              cycle: this.dataForm.cycle,
              times: this.dataForm.times
            })
            break
          default:
            this.dataForm.config = JSON.stringify({
              times: this.dataForm.times
            })
            break
        }
        this.dataForm.measureId = []
        // this.$refs.tree.getCheckedNodes().map((item) => {
        //   if (item.children.length === 0) {
        //     this.dataForm.measureId.push(item.measureId)
        //   }
        // })
        this.dataForm.measureId = this.$refs.tree.getCheckedKeys()
        const serviceSpecification = {
          projectId: this.row.projectId,
          type: this.dataForm.type,
          config: this.dataForm.config
        }
        const projectInServiceRegion = {
          projectId: this.row.projectId,
          regionId: this.dataForm.regionId
        }
        const projectServiceScope = {
          projectId: this.row.projectId,
          measureIds: this.dataForm.measureId
        }
        let serviceSpecificationSuccess = false
        let projectInServiceRegionSuccess = false
        let projectServiceScopeSuccess = false
        Promise.all([
          // 服务规格
          this.$api.contract[ this.isNewServiceSpecification ? 'addServiceSpecification' : 'modifySpecificationConfig']({ ...serviceSpecification }).then((res) => {
            if (res.success) {
              serviceSpecificationSuccess = true
            }
          }),
          // 服务区域
          this.isNewProjectInServiceRegion ?
          this.$api.contract.addProjectInServiceRegion({...projectInServiceRegion}).then((res) => {
            if (res.success) {
              projectInServiceRegionSuccess = true
            }
          }): projectInServiceRegionSuccess = true,
          // 项目服务范围信息
          this.isNewProjectServiceScope ?
          this.$api.contract.addProjectServiceScope({ ...projectServiceScope }).then((res) => {
            if (res.success) {
              projectServiceScopeSuccess = true
            }
          }): projectServiceScopeSuccess = true,
        ]).then(() => {
          this.dialogLoading = false
          if (serviceSpecificationSuccess && projectInServiceRegionSuccess && projectServiceScopeSuccess) {
            this.$message.success('操作成功')
            this.visible = false
            this.$emit('handleQuery')
          }
        }).catch(() => { this.dialogLoading = false })
      })
    }, 1000, { 'leading': true, 'trailing': false }) 
  }
}
</script>

<style lang="scss" scoped>
.dialog-simple {
  text-align: left;
}

.tree-content {
  max-height: 280px;
  overflow: auto;
}

.tree-content {
  ::v-deep .el-checkbox.is-disabled.is-checked {
    color: #409EFF;
    .el-checkbox__inner {
      background-color: #409EFF;
      border-color: #409EFF;
      &::after {
        border-color: #FFF;
      }
    }
  }
}
</style>
